module.exports = __webpack_public_path__ + "img/20_dice[10].c9ce6e27.png";